import { mutateApi } from "src/utils/api/ApiMethods"

export const createJob = (
  marinaSlug,
  workOrderSequentialId,
  {
    name,
    description,
    lineItems = [],
    templateId = null,
    saveAsTemplate = false,
  }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs`,
    method: "POST",
    data: {
      job: {
        name,
        description,
        save_as_template: saveAsTemplate,
        template_id: templateId,
        line_items: lineItems.map(
          ({ productId, pricePerUnit, quantity, notes }) => ({
            product_id: productId,
            price_per_unit: pricePerUnit,
            quantity,
            notes: notes ?? "",
          })
        ),
      },
    },
  }).then((response) => response.data)

export const deleteJob = (marinaSlug, workOrderSequentialId, jobId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}`,
    method: "DELETE",
  }).then((response) => response.data)

export const updateJob = (
  marinaSlug,
  workOrderSequentialId,
  jobId,
  { name, description }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}`,
    method: "PATCH",
    data: { job: { name, description } },
  }).then((response) => response.data)

export const startJob = (marinaSlug, workOrderSequentialId, jobId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}/start`,
    method: "POST",
  }).then((response) => response.data)

export const completeJob = (marinaSlug, workOrderSequentialId, jobId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}/complete`,
    method: "POST",
  }).then((response) => response.data)

export const reopenJob = (marinaSlug, workOrderSequentialId, jobId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}/reopen`,
    method: "POST",
  }).then((response) => response.data)

export const holdJob = (marinaSlug, workOrderSequentialId, jobId, holdReason) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}/hold`,
    method: "POST",
    data: { job: { hold_reason: holdReason } },
  }).then((response) => response.data)

export const resumeJob = (marinaSlug, workOrderSequentialId, jobId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/work_orders/${workOrderSequentialId}/jobs/${jobId}/resume`,
    method: "POST",
  }).then((response) => response.data)
